export default "__VITE_ASSET__44eca3ae__"